var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterSquare(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 24C0 4.8 4.8 0 24 0C43.2 0 48 4.8 48 24C48 43.2 43.2 48 24 48C4.8 48 0 43.2 0 24Z",
    fill: "#8282FA"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M39 17.715V30.285C39 35.745 35.745 39 30.285 39H17.715C17.415 39 17.115 38.985 16.83 38.97C14.985 38.85 13.425 38.325 12.195 37.425C11.565 36.99 11.01 36.435 10.575 35.805C9.54 34.38 9 32.52 9 30.285V17.715C9 12.555 11.91 9.36 16.83 9.045C17.115 9.015 17.415 9 17.715 9H30.285C32.52 9 34.38 9.54 35.805 10.575C36.435 11.01 36.99 11.565 37.425 12.195C38.46 13.62 39 15.48 39 17.715Z",
    fill: "white",
    fillOpacity: 0.8
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.24 15.9746H29.745C30.705 15.9746 31.485 16.7546 31.485 17.7146V19.6346C31.485 20.3396 31.05 21.2096 30.615 21.6446L26.865 24.9596C26.34 25.3946 25.995 26.2646 25.995 26.9696V30.7196C25.995 31.2446 25.65 31.9346 25.215 32.2046L24 32.9696C22.86 33.6746 21.3 32.8796 21.3 31.4846V26.8646C21.3 26.2496 20.955 25.4696 20.595 25.0346L17.28 21.5396C16.845 21.1196 16.5 20.3246 16.5 19.7996V17.8046C16.5 16.7546 17.28 15.9746 18.24 15.9746Z",
    fill: "#111827"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSquare);
export default __webpack_public_path__ + "static/media/filterSquare.a56c206479776740445db54f3657326c.svg";
export { ForwardRef as ReactComponent };